import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type PcsCardModel from './pcs-card';
import type PcsProviderModel from './pcs-provider';

export interface PcsCompanyProviderData {
  id?: string;
  type?: string;
  object?: string;
  company?: {
    name?: string;
    address?: {
      city?: string;
      line1?: string;
      line2?: string | null;
      state?: string;
      country?: string;
      postal_code?: string;
    };
  };
  created?: string;
  livemode?: boolean | null;
  metadata?: Record<string, unknown>;
  settings?: unknown;
  capabilities?: Record<string, string>;
  requirements?: unknown;
  tos_acceptance?: unknown;
  future_requirements?: unknown;
}

export default class PcsCompanyModel extends Model {
  @attr declare providerId: string;
  @attr declare providerData: PcsCompanyProviderData;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel | null;

  @belongsTo('pcs-provider', { async: false, inverse: 'pcsCompanies' })
  declare pcsProvider: PcsProviderModel;

  @hasMany('pcs-card', { async: false, inverse: 'pcsCompany' })
  declare pcsCards: PcsCardModel[];

  [Type] = 'pcs-company' as const;
}
